import { render, staticRenderFns } from "./KlaimDetail.vue?vue&type=template&id=3f0ff21e"
import script from "./KlaimDetail.vue?vue&type=script&lang=js"
export * from "./KlaimDetail.vue?vue&type=script&lang=js"
import style0 from "./KlaimDetail.vue?vue&type=style&index=0&id=3f0ff21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports